// The docs published under /docs, in nav order.
//
// Metadata lives here rather than in front matter so the markdown files stay
// plain and we avoid pulling a YAML parser (and a Buffer polyfill) into the
// browser bundle. Adding a doc is a file in public/docs/ plus a line here.
//
// A doc with a `nav` label is promoted to its own item in the header and is
// left off the docs index, so it's one click from anywhere rather than the
// last card on a long page.

export const DOCS = [
  {
    slug: '2026-season',
    title: '2026 Season',
    group: 'Current season',
    summary: 'Format, rules and schedule for the season in progress — including relegation, the Zombie Rule and the 69 Rule.',
  },
  {
    slug: '2025-season',
    title: '2025 Season',
    group: 'Archive',
    summary: 'How the 2025 season played out: final standings, playoff results and every in-season scoring adjustment.',
  },
  {
    slug: '2024-season',
    title: '2024 Season',
    group: 'Archive',
    summary: 'How the 2024 season played out: final standings, playoff results and every in-season scoring adjustment.',
  },
  {
    slug: '2023-season',
    title: '2023 Season',
    group: 'Archive',
    summary: 'The inaugural season — playoff brackets, in-season standings and the adjustments behind them.',
  },
  {
    slug: 'podcast',
    title: 'FantasyPalsCast',
    group: 'Media',
    summary: 'Every episode of the 2023 pod, from the Opening Ceremony through the season finale.',
    nav: 'Podcast',
  },
];

export const findDoc = (slug) => DOCS.find((doc) => doc.slug === slug);

/** Docs promoted to the header, in the order they're declared above. */
export const navDocs = () => DOCS.filter((doc) => doc.nav);

/** Docs listed on the index — the promoted ones have their own nav item. */
export const indexDocs = () => DOCS.filter((doc) => !doc.nav);

/**
 * Previous and next doc for the footer links. Promoted docs are standalone
 * pages, so they neither appear in the sequence nor get links of their own.
 */
export function docNeighbours(slug) {
  const doc = findDoc(slug);
  if (!doc || doc.nav) return { previous: null, next: null };

  const siblings = indexDocs();
  const at = siblings.findIndex((d) => d.slug === slug);
  return {
    previous: at > 0 ? siblings[at - 1] : null,
    next: at !== -1 && at < siblings.length - 1 ? siblings[at + 1] : null,
  };
}

/** Docs grouped for the index page, preserving the order declared above. */
export function groupedDocs() {
  const groups = [];
  for (const doc of indexDocs()) {
    const existing = groups.find((g) => g.name === doc.group);
    if (existing) existing.docs.push(doc);
    else groups.push({ name: doc.group, docs: [doc] });
  }
  return groups;
}
